import { useMutation, useQueryClient } from "@tanstack/react-query"
import { toast } from "react-toastify";
import { interviewKeys } from "./useInterviewCandidate";
import { deleteCandidate } from "src/redux/api/_webinar.api";

export const useDeleteInterviewCandidate = () => {

  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (ids: string[]) => deleteCandidate(ids),

    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: interviewKeys.all,
      });
    },

    onError: (error) => {
      toast.error("Failed to delete candidates");
      console.error(error, "failed to delete interview candidate!");
    },
  });
}